import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from './ui/dialog';
import { Link2, Copy, Share2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ShareStockTakeLink = ({ branchId, supplier, day }) => {
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const create = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${API}/stock-takes/share-link`, {
        branch_id: branchId, supplier_id: supplier.supplier_id, day_of_week: day,
      }, { withCredentials: true });
      setLink({ url: `${window.location.origin}/count/${res.data.token}`, expires: res.data.expires_at });
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed to create link'); }
    finally { setLoading(false); }
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(link.url); toast.success('Link copied'); }
    catch { toast.error('Copy failed. Select the link and copy it manually'); }
  };

  const share = () => navigator.share({ title: `Stock take: ${supplier.supplier_name}`, text: `Please complete the ${supplier.supplier_name} stock take`, url: link.url }).catch(() => {});

  return (
    <>
      <Button variant="outline" size="sm" onClick={create} disabled={loading} data-testid="share-stocktake-link-btn">
        <Link2 className="w-4 h-4 mr-2" />{loading ? 'Creating...' : 'Share Link'}
      </Button>
      <Dialog open={!!link} onOpenChange={(o) => !o && setLink(null)}>
        <DialogContent data-testid="share-link-dialog">
          <DialogHeader>
            <DialogTitle>Stock take link: {supplier.supplier_name}</DialogTitle>
            <DialogDescription>
              Anyone with this link can fill in and save the count (no login needed). It works until{' '}
              {link && new Date(link.expires).toLocaleString()} or until the stock take is submitted.
            </DialogDescription>
          </DialogHeader>
          <Input readOnly value={link?.url || ''} onFocus={(e) => e.target.select()} data-testid="share-link-url" />
          <DialogFooter className="gap-2">
            {navigator.share && (
              <Button variant="outline" onClick={share} data-testid="share-link-native-btn"><Share2 className="w-4 h-4 mr-2" />Share</Button>
            )}
            <Button onClick={copy} data-testid="copy-share-link-btn"><Copy className="w-4 h-4 mr-2" />Copy Link</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
